export default "__VITE_ASSET__DYNKH5CW__"